<template>
  <el-container>
    <el-header>
      <HeaderCom></HeaderCom>
    </el-header>
    <el-main>
      <el-row type="flex" justify="center">
        <el-col :span="24" style="width: 100%;max-width: 1600px;">
          <el-row style="margin-bottom: 24px">
            <el-col :span="24">
              <div class="nav">
                <router-link to="/data/source">
                  <div class="nav-item">
                    <div class="name">
                      <div class="txt">
                        数据分析
                      </div>
                      <div class="sub-txt">
                        Data analysis
                      </div>
                    </div>
                  </div>
                </router-link>
                <div class="nav-item active">
                  <div class="name">
                    <div class="txt">
                      国家基础信息
                    </div>
                    <div class="sub-txt">
                      National basic information
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="40" style="margin-bottom: 24px">
            <el-col :span="6">
              <div class="country">
                <div class="title">
                  <h3>
                    国家
                  </h3>
                  <p>
                    COUNTRY
                  </p>
                </div>
                <div class="content">
                  <div class="item active">
                    <span class="icon">
                      <img
                        src="./../../assets/image/analysis/taiguo.png"
                        alt=""
                      />
                    </span>
                    <span class="txt">
                      泰国
                    </span>
                  </div>
                  <div class="item">
                    <span class="icon">
                      <img
                        src="./../../assets/image/analysis/yuenan.png"
                        alt=""
                        width="91"
                      />
                    </span>
                    <span class="txt">
                      越南
                    </span>
                  </div>
                  <div class="item">
                    <span class="icon">
                      <img
                        src="./../../assets/image/analysis/nalaixiya.png"
                        alt=""
                      />
                    </span>
                    <span class="txt">
                      马来西亚
                    </span>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="11">
              <div class="people">
                <div class="title">
                  <h3>
                    国家人口比例
                  </h3>
                  <p>
                    National population ratio
                  </p>
                </div>
                <div class="content">
                  <Pie></Pie>
                </div>
              </div>
            </el-col>
            <el-col :span="7">
              <div class="sex">
                <div class="title">
                  <h3>
                    国家男女比例
                  </h3>
                  <p>
                    National sex ratio
                  </p>
                </div>
                <div class="content">
                  <div class="item-wrap">
                    <div class="item">
                      <div class="icon">
                        <img
                          src="./../../assets/image/analysis/man.png"
                          alt=""
                        />
                      </div>
                      <p class="info">
                        <span>
                          13400
                        </span>
                        <span>
                          万
                        </span>
                      </p>
                    </div>
                    <div class="item">
                      <div class="icon">
                        <img
                          src="./../../assets/image/analysis/women.png"
                          alt=""
                        />
                      </div>
                      <p class="info">
                        <span>
                          13400
                        </span>
                        <span>
                          万
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="stats">
                    <div
                      class="man"
                      :style="{ width: `${(100 * 13400) / (13400 + 6400)}%` }"
                    >
                      13400
                    </div>
                    <div class="women">
                      6400
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="12">
              <div class="price">
                <div class="content">
                  <Bar
                    type="bar"
                    title="产品价格与销量"
                    :dataset="{
                      source: [
                        [
                          'product',
                          '0~10元',
                          '10~50元',
                          '50~100元',
                          '100~200元',
                          '大于200元',
                        ],
                        ['大红袍', 4313, 8518, 9317, 8518, 9317],
                        ['茉莉花茶', 8311, 7314, 5511, 8518, 9317],
                        ['奶茶', 8614, 6512, 8215, 8518, 9317],
                        ['正山小种', 7214, 5319, 3911, 8518, 9317],
                        ['二点点', 7214, 5319, 3911, 8518, 9317],
                        ['Walnut Brownie2', 7214, 5319, 3911, 8518, 9317],
                      ],
                    }"
                  ></Bar>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="trade">
                <div class="content">
                  <Bar
                    type="line"
                    title="传统线下贸易量"
                    :dataset="{
                      source: [
                        [
                          'product',
                          '2016年',
                          '2017年',
                          '2018年',
                          '2019年',
                          '2020年',
                        ],
                        ['大红袍', 4313, 8518, 9317, 8518, 9317],
                        ['茉莉花茶', 212, 1555, 4875, 9984, 10254],
                        ['奶茶', 5145, 6512, 8215, 2154, 1898],
                        ['正山小种', 7214, 5319, 3911, 8518, 9317],
                        ['二点点', 7214, 5319, 3911, 8518, 9317],
                        ['Walnut Brownie2', 7214, 5319, 3911, 5454, 4847],
                      ],
                    }"
                  >
                  </Bar>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="mark" @click="drawer = true" v-show="!drawer">
        点我
      </div>
      <el-drawer
        size="400px"
        title="我是标题"
        :visible.sync="drawer"
        :direction="direction"
      >
        <div class="drawer-title" slot="title">
          <div class="txt">
            填写产品基本信息
          </div>
          <div class="sub-txt">
            Fill in product information
          </div>
        </div>
        <div class="drawer-content">
          <div class="form-wrap">
            <div class="select-country">
              <div class="product">
                <img src="@/assets/image/product.jpg" alt="" />
              </div>
              <div class="select">
                <div class="item">
                  <el-popover placement="top" trigger="hover">
                    <div slot>
                      <div style="display: flex">
                        <img
                          src="@/assets/image/analysis/taiguo.png"
                          alt=""
                          width="80"
                        />
                        <img
                          src="@/assets/image/analysis/nalaixiya.png"
                          alt=""
                          width="80"
                        />
                        <img
                          src="@/assets/image/analysis/yuenan.png"
                          alt=""
                          width="80"
                        />
                      </div>
                    </div>
                    <img
                      slot="reference"
                      src="@/assets/image/analysis/taiguo.png"
                      alt=""
                      width="91px"
                    />
                  </el-popover>

                  <span>
                    泰国
                  </span>
                  <button>
                    选择国家
                  </button>
                </div>
              </div>
            </div>
            <div class="form-title form-data">
              <div class="label">
                标题
              </div>
              <div class="input">
                <textarea
                  value="福建古法提炼大师精选大红袍茶叶690
克全球包邮"
                ></textarea>
              </div>
            </div>
            <div class="form-price-inventory form-data">
              <div class="form-price">
                <div class="label">
                  价格
                </div>
                <div class="input">
                  <input type="text" style="width:160px" />
                </div>
              </div>
              <div class="form-inventory">
                <div class="label">
                  库存
                </div>
                <div class="input">
                  <input type="text" style="width:160px" />
                </div>
              </div>
            </div>
            <div class="form-description form-data">
              <div class="label">
                描述
              </div>
              <div class="input">
                <textarea
                  value="福建古法提炼大师精选大红袍茶叶690
克全球包邮"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="other-country">
            <div class="other-item">
              <div class="select-country">
                <div class="product">
                  <img src="@/assets/image/product2.jpg" alt="" />
                </div>
                <div class="select">
                  <div class="item">
                    <img
                      src="@/assets/image/analysis/nalaixiya.png"
                      alt=""
                      width="54px"
                    />
                    <span>
                      马来西亚
                    </span>
                    <button>
                      选择
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="other-item">
              <div class="select-country">
                <div class="product">
                  <img src="@/assets/image/product3.jpg" alt="" />
                </div>
                <div class="select">
                  <div class="item">
                    <img
                      src="@/assets/image/analysis/yuenan.png"
                      alt=""
                      width="54px"
                    />
                    <span>
                      越南
                    </span>
                    <button>
                      选择
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
    </el-main>
  </el-container>
</template>

<script>
import HeaderCom from "../../components/headerCom";
import Pie from "./../../components/echarts/pie";
import Bar from "./../../components/echarts/bar";

export default {
  name: "Analysis",
  components: {
    HeaderCom,
    Pie,
    Bar,
  },
  data() {
    return {
      drawer: false,
      direction: "rtl",
    };
  },
};
</script>

<style scoped lang="scss">
@mixin title {
  padding: 30px 30px 0 30px;
  margin-bottom: 10px;
  h3 {
    font-size: 26px;
    font-weight: bold;
    line-height: 33px;
  }
  p {
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    color: #999999;
  }
}

::v-deep .el-drawer.rtl {
  border-radius: 12px 0 0 12px;
}

div.drawer-title {
  .txt {
    font-size: 26px;
    font-weight: bold;
    line-height: 33px;
    color: #454b60;
  }

  .sub-txt {
    font-size: 12px;
    font-family: Microsoft YaHei UI;
    font-weight: 400;
    line-height: 15px;
    color: #999999;
  }
}

div.drawer-content {
  padding: 0 30px 24px 30px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .form-wrap {
    flex: 1;

    .select-country {
      box-shadow: 0px 0px 20px rgba(158, 158, 158, 0.47);
      height: 230px;
      border-radius: 12px;
      border: 2px solid #f1f1f1;
      display: flex;
      margin-bottom: 42px;

      .product {
        width: 230px;
        border-right: 1px solid #f1f1f1;
        padding: 8px;

        img {
          max-width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .select {
        display: flex;
        justify-content: center;
        flex: 1;

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          color: #999999;

          button {
            margin-top: 30px;
            width: 82px;
            height: 33px;
            background: linear-gradient(312deg, #005be7 0%, #70a0eb 100%);
            box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
            border-radius: 60px;
            font-size: 14px;
            color: white;
            font-family: "Microsoft YaHei", sans-serif;
          }
        }
      }
    }

    .form-data {
      .label {
        height: 18px;
        font-size: 14px;
        font-family: Microsoft YaHei UI, sans-serif;
        font-weight: 400;
        line-height: 18px;
        color: #999999;
        margin-bottom: 8px;
      }

      .input {
        textarea {
          resize: none;
          padding: 8px 18px;
          width: 100%;
          height: 73px;
          background: #ffffff;
          border: 2px solid #f1f1f1;
          border-radius: 12px;
          font-size: 16px;
          font-family: Microsoft YaHei UI, sans-serif;
          font-weight: 400;
        }

        input {
          padding: 0 18px;
          font-size: 16px;
          height: 54px;
          background: #ffffff;
          border: 2px solid #f1f1f1;
          border-radius: 12px;
        }
      }
    }

    .form-title {
      margin-bottom: 18px;
    }

    .form-price-inventory {
      display: flex;
      justify-content: space-between;
      margin-bottom: 18px;
    }
  }

  .other-country {
    display: flex;
    justify-content: space-between;

    .other-item {
      width: 165px;
      height: 111px;
      background: #ffffff;
      border: 2px solid #f1f1f1;
      border-radius: 12px;
      overflow: hidden;

      .select-country {
        height: 100%;
        border-radius: 12px;
        display: flex;
        margin-bottom: 20px;

        .product {
          width: 111px;
          height: 100%;
          border-right: 1px solid #f1f1f1;

          img {
            max-width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .select {
          display: flex;
          justify-content: center;
          flex: 1;

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 10px;
            color: #999999;

            button {
              margin-top: 10px;
              width: 39px;
              height: 18px;
              background: linear-gradient(312deg, #005be7 0%, #70a0eb 100%);
              box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
              border-radius: 60px;
              font-size: 10px;
              color: white;
              font-family: "Microsoft YaHei", sans-serif;
            }
          }
        }
      }
    }
  }
}

.mark {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #005be7;
  color: white;
  text-align: center;
  line-height: 30px;
}

.nav {
  padding: 0 20%;
  height: 84px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .nav-item {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 30px;
    font-family: Microsoft YaHei UI, serif;
    font-weight: bold;
    color: #333333;
    padding: 0 16px;
    margin-right: 160px;
    position: relative;

    .name {
      .txt {
      }

      .sub-txt {
        margin-top: 8px;
        text-align: center;
        font-size: 10px;
        font-weight: 400;
        text-transform: uppercase;
      }
    }

    &.active {
      color: #005be7;

      .name .sub-txt {
        color: #005be7;
      }
    }

    &.active:before {
      content: "";
      position: absolute;
      bottom: 0;
      left: -15px;
      width: calc(100% + 30px);
      height: 8px;
      background: #005be7;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.title {
  @include title;
}

.country {
  height: 418px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 12px;

  .content {
    .item {
      display: flex;
      align-items: center;
      position: relative;
      height: 108px;

      &.active {
        background: #f1f1f1;
      }

      &.active:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 6px;
        height: 100%;
        background: linear-gradient(180deg, #70a0eb 0%, #005be7 100%);
      }

      span.icon {
        padding-left: 20px;
        margin-right: 110px;
      }

      span.txt {
        font-size: 22px;
        font-weight: 400;
        line-height: 28px;
        color: #999999;
      }
    }
  }
}

.people {
  height: 418px;
  background: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 12px;

  .title {
    @include title;
  }

  .content {
  }
}

.sex {
  height: 418px;
  background: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 12px;

  .title {
    @include title;
  }

  .content {
    padding: 20px;

    .item-wrap {
      padding: 0 26px 0 26px;
      margin-bottom: 34px;
      display: flex;
      justify-content: space-between;

      .item {
        .icon {
          width: 120px;
          height: 120px;

          img {
            object-fit: cover;
          }
        }

        .info {
          span {
            &:first-child {
              height: 40px;
              font-size: 40px;
              font-family: Bahnschrift, serif;
              font-weight: bold;
              line-height: 56px;
              color: #666666;
              letter-spacing: 0;
            }

            &:last-child {
              font-size: 14px;
              font-weight: 400;
              line-height: 18px;
              color: #999999;
            }
          }
        }
      }
    }

    .stats {
      height: 50px;
      background: #f1f1f1;
      border-radius: 100px;
      display: flex;
      padding: 8px;

      .man,
      .women {
        border-radius: 100px;
        height: 100%;
        font-size: 30px;
        font-family: Bahnschrift, serif;
        font-weight: bold;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .man {
        background: linear-gradient(90deg, #005be7 0%, #70a0eb 100%);
        margin-right: 8px;
      }

      .women {
        background: linear-gradient(90deg, #fe4a49 0%, #ff7e7e 100%);
        flex-grow: 1;
        flex-shrink: 1;
      }
    }
  }
}

.price,
.trade {
  height: 388px;
  background: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  border-radius: 12px;

  .title {
    @include title;
    position: absolute;
  }
}
</style>
